<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h4>Detalhar Empresa - {{ empresa?.nomeFantasia }}</h4>
			<form *ngIf="empresa">
				<div class="formgroup">
					<div class="field col-12 md:col-12">
						<p-divider></p-divider>
					</div>
					<p-tabView styleClass="tabview-custom" (onChange)="abaSelecionada($event)">
						<p-tabPanel>
							<ng-template pTemplate="header">
								<i class="pi pi-list"></i>
								<span>Dados Básicos</span>
							</ng-template>

							<div class="p-fluid p-formgrid grid">
								<div class="col-12 md:col-12">
									<h5>Dados Principais</h5>
								</div>
								<div class="form-group field col-12 md:col-6">
									<label>Nome Empresa</label>
									<label class="form-control">{{ empresa.nomeFantasia }}</label>
								</div>
								<div class="form-group field col-12 md:col-6">
									<label>Razão Social</label>
									<label class="form-control">{{ empresa.razaoSocial }}</label>
								</div>
								<div class="form-group field col-12 md:col-3">
									<label>CNPJ</label>
									<p-inputMask mask="99.999.999/9999-99" type="text" name="cnpj" id="cnpj"
										[readonly]="true" [ngModel]="empresa.cnpjCpf"></p-inputMask>
								</div>

								<div class="col-12 md:col-12">
									<h5>Contatos</h5>
								</div>

								<div class="form-group field col-12 md:col-3">
									<label>Telefone</label>
									<label class="form-control">{{ empresa.telefone }}</label>
								</div>

								<div class="form-group field col-12 md:col-3">
									<label>WhatsApp</label>
									<label class="form-control">{{ empresa.whatsapp }}</label>
								</div>

								<div class="form-group field col-12 md:col-6">
									<label>E-mail</label>
									<label class="form-control">{{ empresa.email }}</label>
								</div>

								<div class="col-12 md:col-12">
									<h5>Endereço</h5>
								</div>
								<div class="form-group field col-12 md:col-2">
									<label>CEP</label>
									<p-inputMask mask="99999-999" type="text" name="cep" id="cep" [readonly]="true"
										[ngModel]="empresa.cep"></p-inputMask>
								</div>

								<div class="form-group field col-12 md:col-4">
									<label>Logradouro</label>
									<label class="form-control">{{ empresa.logradouro }}</label>
								</div>
								<div class="form-group field col-12 md:col-2">
									<label>Número</label>
									<label class="form-control">{{ empresa.numero }}</label>
								</div>
								<div class="form-group field col-12 md:col-4">
									<label>Bairro</label>
									<label class="form-control">{{ empresa.bairro }}</label>
								</div>
								<div class="form-group field col-12 md:col-4">
									<label>Complementp</label>
									<label class="form-control">{{ empresa.complemento }}</label>
								</div>
								<div class="form-group field col-12 md:col-4">
									<label>Cidade</label>
									<label class="form-control">{{ empresa.cidade }}</label>
								</div>
								<div class="form-group field col-12 md:col-2">
									<label>UF</label>
									<label class="form-control">{{ empresa.uf }}</label>
								</div>

								<div class="col-12 md:col-12">
									<h5>Dados Adicionais</h5>
								</div>

								<div class="form-group field col-12 md:col-2">
									<label>Situação</label>
									<div class="form-control">
										<label class="product-badge status-instock" id="status"
											*ngIf="empresa.ativo">ATIVO</label>
										<label class="product-badge status-outofstock" id="status"
											*ngIf="!empresa.ativo">INATIVO</label>
									</div>
								</div>

								<div class="form-group field col-12 md:col-3">
									<label>Dt. Cadastro</label>
									<label class="form-control">{{ empresa.dataCriacao | date: 'dd/MM/yyyy
										HH:mm:ss'}}</label>
								</div>

								<div class="form-group field col-12 md:col-3">
									<label>Ult. Atualização</label>
									<label class="form-control">{{ empresa.dataAtualizacao | date: 'dd/MM/yyyy
										HH:mm:ss' }}</label>
								</div>
							</div>
							<div class="p-fluid p-formgrid grid justify-content-end">
								<div class="field col-12 md:col-2">
									<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
										class="p-button-primary mt-5" routerLink="/rfarias/empresa"></button>
								</div>
							</div>

						</p-tabPanel>
						<p-tabPanel header="Header II">
							<ng-template pTemplate="header">
								<i class="pi pi-user"></i>
								<span>Usuários</span>
							</ng-template>
							
							<div class="col-12 md:col-12" *ngIf="!exibirListaPermissoesUsuario">
								<h5>Usuários já Vinculados</h5>
							</div>
							<p-table #dt1 [value]="usuarios" dataKey="id" [rows]="10" [loading]="loading"
								[rowHover]="true" styleClass="p-datatable-gridlines" [paginator]="true"
								[globalFilterFields]="['nome', 'apelido', 'email', 'tipo']" responsiveLayout="scroll"
								styleClass=" p-datatable-sm" *ngIf="!exibirListaPermissoesUsuario">
								<ng-template pTemplate="caption">
									<div class="flex justify-content-between flex-column sm:flex-row">

										<button pButton label="Limpar filtro" class="p-button-outlined mb-2"
											icon="pi pi-filter-slash" (click)="limpar(dt1)"></button>
										<span class="p-input-icon-left mb-2">
											<i class="pi pi-search"></i>
											<input pInputText type="text" #filter (input)="buscar(dt1, $event)"
												placeholder="Buscar" class="w-full" />
										</span>
									</div>
								</ng-template>
								<ng-template pTemplate="header">
									<tr>
										<th pSortableColumn="apelido">
											Nome
											<p-sortIcon field="apelido">
											</p-sortIcon>
										</th>
										<th pSortableColumn="email">
											E-mail
											<p-sortIcon field="email">
											</p-sortIcon>
										</th>

										<th>
											<div>
												Ações
											</div>
										</th>

									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item>
									<tr>
										<td>
											{{ item.apelido }}
										</td>
										<td>
											{{ item.email }}
										</td>

										<td>
											<button pButton pRipple pTooltip="Detalhar" icon="pi pi-eye"
												class="p-button-primary mr-2 mb-2"
												(click)="listarPermissaoUsuario(item)">
											</button>
										</td>

									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7">Nenhum registro encontrado.</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="loadingbody">
									<tr>
										<td colspan="7">Carregando usuários. Por favor aguarde.</td>
									</tr>
								</ng-template>
							</p-table>

							<div class="col-12 md:col-12" *ngIf="exibirListaPermissoesUsuario">
								<h5>Permissões Atuais</h5>
								<p-table #dt1 [value]="usuariosPermissoesEmpresas" dataKey="id" [rows]="20"
									[loading]="loading" [rowHover]="true" styleClass="p-datatable-gridlines"
									[paginator]="true" [globalFilterFields]="['descricao']" responsiveLayout="scroll"
									styleClass=" p-datatable-sm" >
									<ng-template pTemplate="caption">
										<div class="flex justify-content-between flex-column sm:flex-row">

											<button pButton label="Limpar filtro" class="p-button-outlined mb-2"
												icon="pi pi-filter-slash" (click)="limpar(dt1)"></button>
											<span class="p-input-icon-left mb-2">
												<i class="pi pi-search"></i>
												<input pInputText type="text" #filter (input)="buscar(dt1, $event)"
													placeholder="Buscar" class="w-full" />
											</span>
										</div>
									</ng-template>
									<ng-template pTemplate="header">
										<tr>
											<th pSortableColumn="descricao">
												Descricao
												<p-sortIcon field="descricao">
												</p-sortIcon>
											</th>

										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-item let-i="rowIndex">
										<tr>
											<td>
												{{ item.permissao.descricao }}
											</td>

										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="7">Nenhum registro encontrado.</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="loadingbody">
										<tr>
											<td colspan="7">Carregando usuários. Por favor aguarde.</td>
										</tr>
									</ng-template>
								</p-table>
							</div>
							<div class="p-fluid p-formgrid grid justify-content-end">
								<div class="field col-12 md:col-2">
									<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
										class="p-button-primary mt-5" (click)="voltar()"></button>
								</div>
							</div>
						
						</p-tabPanel>
						<p-tabPanel header="Planos">
							<ng-template pTemplate="header">
								<i class="pi pi-user mr-1"></i>
								<span>Planos de Contas</span>
							</ng-template>
							<ng-template pTemplate="context">
								<app-plano-contas-empresa-listar *ngIf="eventoAbaPlanoConta == 'LISTAR'" (emissor)="trocarComponentePlanoConta($event)"
								 [empresaSelecionada]="empresa" [modoDetalhar]="true"></app-plano-contas-empresa-listar>
								
								 <app-plano-conta-empresa-detalhar *ngIf="eventoAbaPlanoConta == 'DETALHAR'" [id]="idPlanoContaEmpresa"
								 (emissor)="trocarComponentePlanoConta($event)"
								 ></app-plano-conta-empresa-detalhar>
							</ng-template>
						</p-tabPanel>
						<p-tabPanel header="Tributação">
							<ng-template pTemplate="header">
								<i class="pi pi-user mr-1"></i>
								<span>Tributação</span>
							</ng-template>
							<ng-template pTemplate="context">
								<app-tributacao-listar *ngIf="eventoAbaTributacao == 'LISTAR'"
								[empresa]="empresa" [modoDetalhar]="true"></app-tributacao-listar>
							</ng-template>
						</p-tabPanel>
					</p-tabView>
				</div>
			</form>

		</div>
	</div>
</div>